import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  InfoWindow,
} from 'react-google-maps';
import {
  createProfileRoute,
  prettifyOscarDate,
} from '../../../shared/Helpers';
import { GOOGLE_MAPS_NAV_LINK } from '../../../shared/Constants';
import niaMarker from '../../../static/img/icons/location_icon.png';
import calendarIcon from '../../../static/img/icons/calendar_icon.svg';

const styles = theme => ({
  mapContainer: {
    height: '100%',
    width: '100%',
  },
  infoWindow: {
    maxWidth: 200,
  },
  link: {
    textDecoration: 'none',
    fontSize: 15,
    color: theme.palette.text.secondary,
    '&:visited': {
      color: theme.palette.text.secondary,
    },
  },
  infoWindowAction: {
    display: 'flex',
    justifyContent: 'center',
  },
  infoWindowButton: {
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    fontSize: 10,
  },
  niaMarker: {
    verticalAlign: 'text-bottom',
    height: 22,
    width: 22,
  },
  subtitle: {
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 3,
    padding: theme.spacing(),
    fontSize: 18,
  },
  eventImg: {
    marginBottom: 4,
    height: 22,
    width: 22,
    verticalAlign: 'text-bottom',
    marginRight: theme.spacing(),
  },
  trainerLinkP: {
    textAlign: 'center',
    fontSize: '0.9rem',
    paddingBottom: theme.spacing(),
  },
  trainerLink: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
    '&:visited': {
      color: theme.palette.primary.dark,
    },
    textTransform: 'uppercase',
    letterSpacing: 2,
  },
  classTimesHeader: {
    textTransform: 'uppercase',
    paddingBottom: theme.spacing(),
  },
  locationAddress: {
    fontSize: 12,
  },
});

function MyInfoWindow(props) {
  const {
    id,
    open,
    onCloseMapWindow,
    event,
    classes,
    handlePopupOpen,
  } = props;

  const renderLocationTitle = (item) => {
    if (item.distance === undefined || item.distance === null) {
      return item.location.title;
    }
    return item.location.title + ' (' + item.distance.substring(0, 3) + 'mi)';
  };

  const renderButton = (event) => {
    if (event.event_type.depends_on_text !== '') {
      return (
        <Button
          onClick={e => handlePopupOpen(e, event.event_type.depends_on_text, event.event_type.depends_on_checkbox, event.link)}
          variant="contained"
          color="secondary"
          className={classes.infoWindowButton}
        >
          Learn More
        </Button>
      );
    }
    return (
      <Button target="_blank" variant="contained" color="secondary" className={classes.infoWindowButton} href={event.link}>Learn More</Button>
    );
  };

  if (id === open) {
    return (
      <InfoWindow onCloseClick={() => onCloseMapWindow()}>
        <div className={classes.infoWindow}>
          <Typography variant="h5" className={classes.subtitle}>
            <img src={event.event_type.img} className={classes.eventImg} alt="class type icon" />
            {event.event_type.level}
          </Typography>
          <Typography variant="h5" className={classes.trainerLinkP}>
            <Link target="_blank" rel="noopener noreferrer" className={classes.trainerLink} to={createProfileRoute(event.user.username)}>
              {event.user.first_name + ' ' + event.user.last_name}
            </Link>
          </Typography>
          {/* ADDRESS */}
          {event.location
            ? (
              <React.Fragment>
                <Typography color="textSecondary" className={classes.classTimesHeader}>
                  <Link to={'/location/' + event.location.id} className={classes.link}>
                    <img alt="nia marker" className={classes.niaMarker} src={niaMarker} />
                    {renderLocationTitle(event)}
                  </Link>
                  <span className={classes.locationAddress}>{' - ' + event.location.address + ' '}</span>
                </Typography>
              </React.Fragment>
            )
            : (
              <Typography color="textSecondary" className={classes.classTimesHeader}>
                <img alt="nia marker" className={classes.niaMarker} src={niaMarker} />
                No Location
              </Typography>
            )
          }
          {/* CLASS TIMES COLUMN */}
          <Typography color="textSecondary" className={classes.classTimesHeader}>
            <img alt="calendar" className={classes.niaMarker} src={calendarIcon} />
            {' ' + prettifyOscarDate(event.start_date) + ' - ' + prettifyOscarDate(event.end_date)}
          </Typography>
          <div className={classes.infoWindowAction}>
            <Button variant="outlined" size="small" color="secondary" className={classes.infoWindowButton} target="_blank" rel="noopener noreferrer" href={GOOGLE_MAPS_NAV_LINK + encodeURIComponent(event.location.address)}>Directions</Button>
            {renderButton(event)}
          </div>
        </div>
      </InfoWindow>
    );
  }
  return null;
}

class MapComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      latitude,
      longitude,
    } = this.props.coords;
    const {
      zoom,
      events,
      openWindow,
      onOpenMapWindow,
      onCloseMapWindow,
      classes,
      loading,
      handlePopupOpen,
    } = this.props;
    return (
      <div className={classes.mapContainer}>
        <GoogleMap
          zoom={zoom}
          center={{ lat: latitude, lng: longitude }}
        />
        {!loading
          && (
            <React.Fragment>
              {events.map(event => (
                <React.Fragment key={event.id}>
                  {event.location
                    && (
                      <Marker
                        icon={niaMarker}
                        key={event.id}
                        position={{
                          lat: parseFloat(event.location.geo_point.coordinates[1]),
                          lng: parseFloat(event.location.geo_point.coordinates[0]),
                        }}
                        onClick={() => onOpenMapWindow(event)}
                      >
                        <MyInfoWindow
                          id={event.id}
                          open={openWindow}
                          onCloseMapWindow={onCloseMapWindow}
                          event={event}
                          classes={classes}
                          handlePopupOpen={handlePopupOpen}
                        />
                      </Marker>
                    )
                  }
                </React.Fragment>
              ))}
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

MapComponent.propTypes = {
  coords: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  events: PropTypes.array.isRequired,
  onOpenMapWindow: PropTypes.func.isRequired,
  onCloseMapWindow: PropTypes.func.isRequired,
  openWindow: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  handlePopupOpen: PropTypes.func.isRequired,
};

MyInfoWindow.propTypes = {
  id: PropTypes.number.isRequired,
  open: PropTypes.number.isRequired,
  onCloseMapWindow: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  handlePopupOpen: PropTypes.func.isRequired,
};

export default withStyles(styles)(withGoogleMap(MapComponent));
